import axios from 'axios'

const axiosInstance = axios.create({
  headers: { 'Content-Type': 'application/json' },
})

axiosInstance.interceptors.response.use(
  // eslint-disable-next-line consistent-return
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // if the user is not logged in (response?.data?.developer is undefined) then reload the page - Show logged out experience

    /*if (!response?.data || response?.data?.developer) {
      return response
    }
    window.location.reload()*/
    return response
  },
  function (err) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (err?.response?.status === 401) {
      window.location.reload()
    }
    return Promise.reject(err)
  },
)

export default axiosInstance
